import type {
  CreditConsultation,
  CreditConsultationValue,
} from '@/shared/api/resources';
import { formatCnae, formatMoney } from '@/shared/lib/format';

/** O tipo da consulta, como a tela chama. */
export function tipoDaConsulta(consulta: CreditConsultation): string {
  if (consulta.stage === 'master') return 'Master';
  if (consulta.stage === 'basica') return 'Basica';
  return '-';
}

/** O valor como a tela mostra: dinheiro em reais, e a falta dita como falta. */
export function textoDoValorDaConsulta(
  valor: CreditConsultationValue | undefined,
  cnae = false,
): string {
  if (!valor) return '';
  if (valor.situation !== 'encontrado') {
    if (valor.situation === 'invalido') return 'invalido (fora do formato)';
    if (valor.situation === 'nao_encontrado') return 'nao encontrado';
    return valor.situation.replace(/_/g, ' ');
  }
  if (valor.value_money) return formatMoney(valor.value_money);
  if (valor.value_integer !== null && valor.value_integer !== undefined) {
    return String(valor.value_integer);
  }
  if (valor.value_flag !== null && valor.value_flag !== undefined) {
    return valor.value_flag ? 'Sim' : 'Nao';
  }
  if (valor.value_date) return valor.value_date;
  if (valor.value_text) return cnae ? formatCnae(valor.value_text) : valor.value_text;
  return '';
}
